import { createApp } from 'vue'
import SimpleSearchButton from './simple-search-button.vue'


document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById('simpleSuchButton');
    if (!el) return

    const app= createApp(SimpleSearchButton);
    app.mount( el );
})

